// extracted by mini-css-extract-plugin
export default {"venueContainer":"venue_venueContainer__RzoZA","venueAddress":"venue_venueAddress__JvQI5"};